import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { useMappingService, useTrackingService } from './serviceHooks';
import { useCallback } from 'react';

export const useProductEngagementTracker = (request: IRequestContext, telemetry: ITelemetry) => {
    const relewiseTrackingService = useTrackingService(request, telemetry);

    const trackProductEngagement = (relewiseProductId: string | undefined, relewiseVariantId: string | undefined, isFavorite: boolean) => {
        if (!relewiseProductId || !relewiseVariantId) {
            return;
        }

        relewiseTrackingService.trackProductEngagement(relewiseProductId, isFavorite, relewiseVariantId);
    };

    return { trackProductEngagement };
};

// TODO: Remove this hook when wishlist is refactored
// Necessary for tracking product engagement with MS simple product model
export const useMsCommerceProductEngagementTracker = (
    product: SimpleProduct | undefined,
    request: IRequestContext,
    telemetry: ITelemetry
) => {
    const relewiseTrackingService = useTrackingService(request, telemetry);
    const relewiseMappingService = useMappingService(request, telemetry);

    const trackProductEngagement = useCallback(
        (isFavorite: boolean) => {
            if (!product || !product.ItemId) {
                return;
            }

            const variantId = relewiseMappingService.mapSimpleProductToRelewiseVariantId(product);
            relewiseTrackingService.trackProductEngagement(relewiseMappingService.prefixId(product.ItemId), isFavorite, variantId);
        },
        [product, relewiseMappingService, relewiseTrackingService]
    );

    return { trackProductEngagement };
};
